<template>
  <div class="app flex-row align-items-center">
    <div class="my-5"></div>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-row>
            <b-col class="text-center pb-4">
              <div class="w-50 d-inline-block">
                <img src="img/brand/sf-logo.svg">
              </div>
            </b-col>
          </b-row>
          <b-card
            img-src="img/login.jpg"
            img-alt="Image"
            img-top
            tag="article"
            class="mb-2">
            <b-form class="px-4">
              <b-alert show :variant="error_variant" v-if="error_msg">{{error_msg}}</b-alert>
              <b-input-group class="mb-3">
                <b-form-input type="text" class="form-control text-center" placeholder="Your email" autocomplete="username email"  v-model="username" />
              </b-input-group>
              <b-input-group class="mb-4" v-if="!update_password">
                <b-form-input type="password" class="form-control text-center" placeholder="Your password" autocomplete="current-password"  v-model="password" />
              </b-input-group>
              <b-input-group class="mb-4" v-if="update_password">
                <b-form-input type="password" class="form-control text-center" placeholder="Your new Password" autocomplete="new-password"  v-model="new_password" />
              </b-input-group>
              <b-row>
                <b-col>
                  <b-button v-if="!loading" variant="sf" block class="text-uppercase font-weight-bold py-2" v-on:click="signIn">Log In</b-button>
                  <b-button v-if="loading" variant="dark" block class="text-uppercase font-weight-bold py-2"><i class="fal fa-spin fa-spinner"></i> Logging In</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
          <b-row>
            <b-col>
              <b-button variant="link" block class="px-0 pt-1 pb-0 text-center font-weight-bold" to="/recover-password">Recover password?</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {AUTH_LOGIN, AUTH_CHECK_LOGIN, AUTH_RESET_PASSWORD} from '@/store/action-types';

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      username: this.$store.getters.getAuthEmail,
      password: null,
      new_password: null,
      code: null,
      error_msg: null,
      error_variant: 'warning',
      update_password: false,
      confirm_account: false
    }
  },
  methods: {

    signIn: function() {

      // if(this.username === 'internal@tangle.ca') {
      //   localStorage.setItem('auth_token', 'test');
      //   this.$router.push('/dashboard');
      // } else if(this.username === 'lance@revelventures.com') {
      //   localStorage.setItem('auth_token', 'test');
      //   localStorage.setItem('customer_id', '82');
      //   this.$router.push('/dashboard');
      // } else {
      //   this.error_msg = 'Authentication failed.';
      // }
      // return;

      this.loading = true;
      const username = this.username;
      const password = this.password;
      const new_password = this.new_password;
      this.error_msg = null;

      //console.log('login-test-1');
      if(this.update_password && this.$store.getters.getAuthSession) {
        return this.$store.dispatch(AUTH_RESET_PASSWORD, {username, password: new_password}).then(() => {
          this.loading = false;
          this.username = this.$store.getters.getAuthEmail;
          this.password = null;
          this.new_password = null;
          this.code = null;
          this.error_msg = null;
          this.update_password = false;
          this.confirm_account = false;
        }).catch(() => {
          //console.log('login-test-3');
          const error = this.$store.getters.getAuthenticationError;
          if(error) {
            this.error_msg = error
          } else {
            this.error_msg = 'Something went wrong please contact an administrator';
          }
          this.error_variant = 'warning';
          this.loading = false;
        });
      } else {
        //console.log('login-test-4');
        return this.$store.dispatch(AUTH_LOGIN, {username, password}).then(() => {
          //console.log('login-test-5');
          if(this.$store.getters.getAuthenticationStatus === 'SIGN_IN_CHALLENGE') {
            //console.log('login-test-6');
            this.update_password = true;
            this.error_msg = 'Your temporary password was accepted. Please enter a new password for the account.';
            this.error_variant = 'info';
            this.loading = false;
          } else {
            //console.log('login-test-7');
            this.$router.push('/dashboard');
          }
        }).catch((err) => {
          //console.log('login-test-8');
          const error = this.$store.getters.getAuthenticationError;
          if(error) {
            this.error_msg = error
          } else {
            this.error_msg = 'Something went wrong please contact an administrator';
          }
          this.error_variant = 'warning';
          this.loading = false;
        });
      }

    },

    toRegister: function() {
      this.$router.push('/register');
    }

  },
  async beforeCreate() {
    this.$store.dispatch(AUTH_CHECK_LOGIN, {}).then(data => {
      this.$router.push('/dashboard');
    }).catch((e) => {
      //:: TODO handle check
    });
  }
}
</script>
